import React, { useEffect, useLayoutEffect, useState } from "react";
import { Row, Col, message } from "antd";
import { useParams, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import SetPasswordForm from "../../../forms/SetPasswordForm";
import schema from "../../../schemas/resetPasswordSchema";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import { sliceKey, reducer, actions } from "./slice";
import { verifyUserSaga } from "./saga";
import * as selectors from "./selectors";
// import { useAuth } from "../../../contexts/auth";
import "./style.css";

/* const styles = {
  loginPage: {
    height: "100%",
  },

  bgLogin: {
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "60%",
  },
}; */
const VerifyAccountPage = () => {
  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: verifyUserSaga });
  const dispatch = useDispatch();

  const { search } = useLocation();
  // const history = useHistory();
  // const auth = useAuth();

  const query = new URLSearchParams(search);
  const resetToken = query.get("resetToken");
  const { token } = useParams();

  const loading = useSelector(selectors.selectLoading);
  const error = useSelector(selectors.selectError);

  useEffect(() => {
    if (error && error !== "") {
      message.error(error);
      setTimeout(() => {
        dispatch(actions.initializeError());
      }, 1000);
    }
  }, [error, dispatch]);

  const [col, setCol] = useState(12);

  useLayoutEffect(() => {
    function updateCol() {
      if (window.innerWidth < 660) setCol(24);
      else setCol(12);
    }
    window.addEventListener("resize", updateCol);
    updateCol();
    return () => window.removeEventListener("resize", updateCol);
  }, []);
  const handleSuccess = () => {
    // auth.fetchLoggedInUser();
    // history.push("/");
    window.location.href = "/";

  };
  const submitForm = (data) => {
    dispatch(
      actions.verifyUserAndSetPassword({
        token,
        data: { resetToken, password: data.password },
        onSuccess: handleSuccess,
      })
    );
  };

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      password: "",
      passwordConfirm: "",
    },
    resolver: yupResolver(schema),
  });

  return (
    <Row gutter={32} style={{ height: "100%" }}>
      <Col span={col} className="bgImage">
        <div
          /*   style={{
            ...styles.bgLogin,
            backgroundImage: `url(${loginBg})`,
            height: "100%",
          }} */
          className="bgVerifyAccount"
        />
      </Col>
      <Col span={col}>
        <SetPasswordForm
          control={control}
          errors={errors}
          onSubmit={handleSubmit(submitForm)}
          loading={loading}
        />
      </Col>
    </Row>
  );
};

export default VerifyAccountPage;
